function keyToID(key) {
  if (typeof key !== 'string') return '';
  return key.toLowerCase().replaceAll('-', '_');
}

export default keyToID;
